import React from 'react';
import {useTranslations, createTranslator} from 'next-intl';
import {Grid, Row, Col} from '@/grid';
import withMainLayout from 'layouts/main';
import {SectionPadding, SectionPaddingTopAd} from '@/section';
import Container from '@/container';
import Link from '@/links';
import {withBgLegalPages} from '@/hocs/withColors';
import {withBoldWeight} from '@/hocs/withFontType';
import {H1Neutral50, P, PMarginTMd} from '@/typography';

import CookiesTable from '@/content/cookies-list/cookies-table';
import {NecessaryCookies} from '@/content/cookies-list/necessary-cookies';
import {FunctionalityCookies} from '@/content/cookies-list/functionality-cookies';
import {AnalyticsCookies} from '@/content/cookies-list/analytics-cookies';
import {AdvertisingCookies} from '@/content/cookies-list/advertising-cookies';

import legal from 'pages/legal/legal.module.scss';
import {pageMessagesProps} from 'helpers/i18n';
import shared from '../messages/en/shared.json';
import cookiesList from '../messages/en/cookiesList.json';

const SectionTitle = withBgLegalPages(SectionPadding);
const BoldSpan = withBoldWeight('span');

const seoMetas = props => {
  const seoT = createTranslator({locale: props.locale, messages: props.messages});
  return {
    title: seoT('cookiesList.seo.title'),
    description: seoT('cookiesList.seo.description'),
    canonical: seoT('cookiesList.seo.canonical')
  };
};

const CookiesPolicyPage = () => {
  const t = useTranslations('cookiesList');

  return (
    <>
      <SectionPaddingTopAd>
        <SectionTitle>
          <Container>
            <Grid fluid>
              <Row>
                <Col xs={12}>
                  <H1Neutral50>{t('heading')}</H1Neutral50>
                </Col>
              </Row>
            </Grid>
          </Container>
        </SectionTitle>
      </SectionPaddingTopAd>
      <Container>
        <SectionPadding>
          <Grid fluid>
            <Row>
              <Col xs={12}>
                <BoldSpan>{t('aboutCookies.label')}</BoldSpan>
                <PMarginTMd>{t('aboutCookies.description')}</PMarginTMd>
                <CookiesTable
                  className={legal['legal-table']}
                  sectionTitle={t('categories.necessary.title')}
                  sectionDescription={t('categories.necessary.description')}
                  cookiesTable={NecessaryCookies.cookiesTable}
                />
                <CookiesTable
                  className={legal['legal-table']}
                  sectionTitle={t('categories.functionality.title')}
                  sectionDescription={t('categories.functionality.description')}
                  cookiesTable={FunctionalityCookies.cookiesTable}
                />
                <CookiesTable
                  className={legal['legal-table']}
                  sectionTitle={t('categories.analytics.title')}
                  sectionDescription={t('categories.analytics.description')}
                  cookiesTable={AnalyticsCookies.cookiesTable}
                />
                <CookiesTable
                  className={legal['legal-table']}
                  sectionTitle={t('categories.advertising.title')}
                  sectionDescription={t('categories.advertising.description')}
                  cookiesTable={AdvertisingCookies.cookiesTable}
                />
                <P>
                  {t.rich('contactParagraph', {
                    a: chunks => (
                      <Link href="mailto:support@workable.com" target="_top" variant="default">
                        {chunks}
                      </Link>
                    )
                  })}
                </P>
                <P>{t('lastUpdated')}</P>
              </Col>
            </Row>
          </Grid>
        </SectionPadding>
      </Container>
    </>
  );
};

export default withMainLayout(CookiesPolicyPage, seoMetas);

export const messagesForIntl = {shared, cookiesList};

export function getStaticProps() {
  return pageMessagesProps(messagesForIntl);
}
